//
//
//
//
//
//
//
//


import myFooter from './components/foort';
import myLiulanqi from './components/liulanqi'

export default {
  name: 'App',
  components: {
      myFooter,
      myLiulanqi
    },
    data () {
      return {
        llq:0
      }
    },
    created(){
      this.setting();
      let ua = navigator.userAgent.toLowerCase();
      		if (ua.match(/MicroMessenger/i) == "micromessenger") {
      			console.log('微信浏览器');
            // this.llq=1;
      		}else{
      			console.log('普通浏览器');
      			// this.llq=1;
      }
    },
    methods: {
      setting: function() {
    	if(typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
    		handleFontSize();
    	} else {
    		if(document.addEventListener) {
    			document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
    		} else if(document.attachEvent) {
    			document.attachEvent("WeixinJSBridgeReady", handleFontSize);
    			document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
    		}
    	}
    	function handleFontSize() {
    		// 设置网页字体为默认大小
    		WeixinJSBridge.invoke('setFontSizeCallback', {
    			'fontSize': 0
    		});
    		// 重写设置网页字体大小的事件
          	WeixinJSBridge.on('menu:setfont', function() {
    			WeixinJSBridge.invoke('setFontSizeCallback', {
    				'fontSize': 0
    			});
    		});
    	}
      }
    }
}



// WEBPACK FOOTER //
// ./src/App.vue